import { useState } from "react";
import { SettingsSection } from "./SettingsSection";
import { AddressRow } from "../Rows/AddressRow";
import { SaveAddressModal } from "../Modals/SaveAddressModal";
import { AddButton } from "../Buttons/AddButton";
import { SaveAddressForm } from "../Form/Forms/Address/SaveAddressForm";

export function Addresses({ addresses }) {
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const [editingAddressId, setEditingAddressId] = useState(null);

  return (
    <>
      <SaveAddressModal open={openSaveModal} setOpen={setOpenSaveModal} />

      <SettingsSection title="Addresses">
        {addresses?.length > 0 && (
          <ul className="space-y-4">
            {addresses.map((a) => (
              <li key={a.addressId} className="space-y-2">
                {/* Address Row */}
                <AddressRow
                  address={a}
                  isEditing={editingAddressId === a.addressId}
                  setEditingAddressId={setEditingAddressId}
                />

                {/* Inline Edit Form */}
                {editingAddressId === a.addressId && (
                  <div className="p-4 border border-gray-100 rounded-lg">
                    <SaveAddressForm
                      selectedAddress={a}
                      setOpen={() => setEditingAddressId(null)}
                    />
                  </div>
                )}
              </li>
            ))}
          </ul>
        )}

        {addresses?.length < 10 && (
          <div className="mt-2 flex justify-start">
            <AddButton
              onClick={() => setOpenSaveModal(true)}
              text="Add another address"
            />
          </div>
        )}
      </SettingsSection>
    </>
  );
}